export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.bd07b94ebe132f5e6d52.worker.js");
}
